<template>
  <div class="seade">
    <div class="seade_header col-12 d-inline-flex justify-content-between align-items-center p-0">
      <div class="px-2 py-3 d-inline-flex align-items-top">
        <div class="col-5 form-group m-0 p-0 mr-2">
          <label for="mes"
                 class="label seade_label">Mês</label>
          <select id="mes"
                  v-model="localData.mes"
                  v-validate="'required'"
                  name="mes_seade"
                  class="custom-select custom-select-sm"
                  :class="{'is-invalid': errors.has('mes_seade')}">
            <option :value="null">
              Selecione
            </option>
            <option v-for="(month, index) in meses"
                    :key="index"
                    :value="month.value">
              {{ month.text | firstCapitalize }}
            </option>
          </select>
          <span v-if="errors.has('mes_seade')"
                class="invalid-feedback">
            {{ errors.first('mes_seade') }}
          </span>
        </div>
        <div class="col-5 form-group m-0 p-0">
          <label for="ano"
                 class="label">Ano</label>
          <select id="mes"
                  v-model="localData.ano"
                  v-validate="'required'"
                  name="ano_seade"
                  class="custom-select custom-select-sm"
                  :class="{'is-invalid': errors.has('ano_seade')}">
            <option :value="null">
              Selecione
            </option>
            <option v-for="(year, index) in years"
                    :key="index"
                    :value="year">
              {{ year }}
            </option>
          </select>
          <span v-if="errors.has('ano_seade')"
                class="invalid-feedback">
            {{ localData.ano ? errors.first('ano_seade') : "Campo obrigatório" }}
          </span>
        </div>
        <div class="pt-3">
          <button class="btn btn-outline-primary btn-sm ml-2 mt-2 px-3"
                  @click="searchMes()">
            Pesquisar
          </button>
        </div>
      </div>
    </div>
    <div v-if="showMes"
         class="seade_body">
      <DetalheMes :prop-mes="mes"
                  @gerarTodos="enviarTipos"
                  @gerar="gerar" />
    </div>

    <div v-else
         class="seade_footer d-flex justify-content-center align-items-center p-2">
      Pesquise por um período de mês e ano para visualizar a comunicação
    </div>
  </div>
</template>
<script>
  /* components */
  import DetalheMes from "./DetalheMes"

  /* services */
  import SeadeService from "@/services/SeadeService"

  /* libraries */
  import JSZip from "jszip"
  import FileSaver from "file-saver"
  import Swal from 'sweetalert2'
  import moment from 'moment'
  import {mapGetters} from "vuex"

  export default {
    name: "Seade",
    components: {
      DetalheMes
    },
    data () {
      return {
        yearList: [],
        mes: {},
        showMes: false,
        meses: [
          {text: 'janeiro', value: "01"},
          {text: 'fevereiro', value: "02"},
          {text: 'março', value: "03"},
          {text: 'abril', value: "04"},
          {text: 'maio', value: "05"},
          {text: 'junho', value: "06"},
          {text: 'julho', value: "07"},
          {text: 'agosto', value: "08"},
          {text: 'setembro', value: "09"},
          {text: 'outubro', value: "10"},
          {text: 'novembro', value: "11"},
          {text: 'dezembro', value: "12"},
        ],
        types: [
          {text: "nascimento", value: 'nascimento', icon: 'nascimento', type: "N"},
          {text: "casamento", value: 'casamento', icon: 'engagement', type: "C"},
          {text: "casamento religioso", value: 'casamento_religioso', icon: 'calendar', type: "CR"},
          {text: "óbito", value: 'obito', icon: 'flower', type: "O"},
          {text: "natimorto", value: 'natimorto', icon: 'ribbon', type: "NT"},
        ],
        localData: {
          mes: null,
          ano: null,
          cartorio_id: this.$store.state.auth.cartorio_id
        },
        months: [],
        search: {},
        years: []
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    mounted () {
      this.getYears()
    },
    methods: {
      getYears () {
        const year = moment().year()

        for (let ano = year; ano >= 1900; ano--) {
          this.years.push(ano)
        }
      },
      async searchMes () {
        const valid = await this.$validator.validate()

        if (!valid) return

        try {
          loader({active: true, text: ""})

          this.search = {...this.localData}

          const res = await SeadeService.index(this.localData)

          const mes = this.meses.find(mes => mes.value == this.localData.mes)

          this.mes = {...res, ano: this.localData.ano, mes: mes.text}
        } catch (error) {
          return this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
          this.showMes = true
        }
      },
      async enviarTipos (tipos) {
        const arrResponse = []

        try {
          loader({active: true, text: 'Gerando...'})

          for (const tipo of tipos) {
            const params = {
              tipo_registro: tipo,
              ano: this.search.ano,
              mes: this.search.mes,
              cartorio_id: this.$store.state.auth.cartorio_id
            }

            const res = await SeadeService.gerarTxt(params)

            // continuamos pois o usuário já pode ter pego algum relatório do seade
            if (res.data.message) continue

            arrResponse.push(res)
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: 'Gerando...'})
        }

        if (arrResponse.length === 0) {
          return this.displayError('', 'Não existem arquivos pendentes de criação')
        }

        return this.gerarZip(arrResponse)
      },
      async gerarZip (arrResponse) {
        try {
          loader({active: true, text: 'Gerando arquivo .zip...'})

          const zip = new JSZip()

          for (const res of arrResponse) {
            const cd = res.headers["content-disposition"]
            const fileName = cd.substring(cd.indexOf('"') + 1,cd.lastIndexOf('"'))

            zip.file(fileName, res.data, { binary: true })
          }

          const content = await zip.generateAsync({ type: 'blob'})

          const mes = this.meses.find(mes => mes.value == this.localData.mes)

          FileSaver.saveAs(content, `seade-${mes.text}-${this.localData.ano}.zip`)

          //busca dados atualizados dos registros
          const mesGerado = await SeadeService.index(this.search)
          this.mes = {...mesGerado, ano: this.localData.ano, mes: mes.text}
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: 'Gerando...'})
        }
      },
      async gerar (tipo) {
        const params = {
          tipo_registro: tipo,
          ano: this.search.ano,
          mes: this.search.mes,
          cartorio_id: this.$store.state.auth.cartorio_id
        }
        try {
          loader({active: true, text: "Gerando..."})
          const res = await SeadeService.gerarTxt(params)

          if (res.data.message) {
            return this.tratarRetornos(tipo, res.data.message)
          }

          //tratar nome do arquivo
          const cd = res.headers["content-disposition"]
          const name = cd.substring(cd.indexOf('"') + 1,cd.lastIndexOf('"'))

          //download do arquivo
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', name)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          //busca dados atualizados dos registros
          const mesGerado = await SeadeService.index(this.search)
          const mes = this.meses.find(mes => mes.value == this.localData.mes)
          this.mes = {...mesGerado, ano: this.localData.ano, mes: mes.text}
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: "Gerando..."})
        }
      },
      displaySuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = ""

        return Swal.fire(objSwal.success)
      },
      displayError (title, text) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ""

        return Swal.fire(objSwal.error)
      },
      tratarRetornos (tipo, message) {
        if (message.match("Não existem arquivos pendentes de criação")) {

          const registro = this.types.find(type => type.type == tipo)

          if (registro) {
            const text = `Não existem arquivos pendentes de criação para o registro de ${registro.text}`
            return this.displayError("", text)
          }
        }

        return this.displayError("Erro!", message)
      }
    }
  }
</script>
<style lang="scss">

  .seade {
    &_header {}
    &_body {}

    &_footer {
      font-size: 16px;
      font-weight: normal;
      color: #ffffff;
      border: solid 1px #074f7f;
      background-color: #074f7f;
    }

    &_label {
      color: #373a3c;
    }
  }

</style>
